import createMuiTheme from 'material-ui/styles/createMuiTheme';

export default createMuiTheme({
  palette: {
    primary: {
      main: '#000000',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#84ffff',
      contrastText: '#212121',
    },
    error: {
      light: '#ffffb0',
      main: '#ffe57f',
      dark: '#cab350',
      contrastText: '#212121',
    },
    text: {
      primary: '#212121',
      secondary: '#212121',
    },
    background: {
      paper: '#ffffff',
      default: '#000000',
    },
  },
});



// WEBPACK FOOTER //
// ./src/utils/materialTheme.js